module.exports = __webpack_public_path__ + "img/12_59.cf8cce5a.png";